var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Gift-Card-Index"},[_c('div',{style:(_vm.indexStyle)},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.bgSrc,"alt":""}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Gift-Card-Index-BOTTOM-Text"},[_c('p',[_vm._v("本次活动已结束，谢谢！")])])
}]

export { render, staticRenderFns }